import api from '@/apis'
import fileDownload from 'js-file-download'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    params: {}
  },
  mutations: {
    INIT_EDIT_INTENT_TITLE_DIALOG(state, payload) {
      state.visibility = true
      state.params = payload
    },
    SET_EDIT_INTENT_TITLE_DIALOG_TITLE(state, payload) {
      state.params.title = payload
    },
    RESET_EDIT_INTENT_TITLE_DIALOG(state) {
      state.visibility = false
      setTimeout(() => {
        state.params = {}
      }, 100)
    }
  },
  actions: {
    async renameIntent({ dispatch, commit, state }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Renaming Intent...', loading: true })
        const response = await api.renameIntent({ params: state.params })
        if (response.data.success) {
          dispatch('fetchQuestionTopicDetails', { intent_id: state.params.id, language: state.params.language })
          commit('RESET_EDIT_INTENT_TITLE_DIALOG')
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async exportIntent({ commit, rootState }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.downloading'), loading: true })
        const device_id = rootState.auth.selected_device
        const response = await api.intentExport(device_id)

        if (response.status === 200) {
          fileDownload(response.data, `${device_id}-intent.xlsx`)
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.download'), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
